import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/invoices/${number | ':invoiceId'}/edit`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/invoices/:invoiceId/edit`;

export const URL = (jobId: number, invoiceId: number): RouteDefinition => `${baseRoute}/${jobId}/invoices/${invoiceId}/edit`;
